import * as Actions from '../../actions/hsse/index';

const initialState = {
    summaryOpen: false,
    reportsOpen: false
}

const dashboard = function (state = initialState, action) {
    switch (action.type) {
        case Actions.CLOSE_ALL: {
            return {
                ...state,
                summaryOpen: false,
                reportsOpen: false
            }
        }
        case Actions.OPEN_SUMMARY: {
            return {
                ...state,
                summaryOpen: true,
                reportsOpen: false
            }
        }
        case Actions.CLOSE_SUMMARY: {
            return {
                ...state,
                summaryOpen: false
            }
        }
        case Actions.TOGGLE_SUMMARY: {
            return {
                ...state,
                summaryOpen: !state.summaryOpen,
                reportsOpen: false
            }
        }
        case Actions.TOGGLE_REPORTS: {
            return {
                ...state,
                summaryOpen: false,
                reportsOpen: !state.reportsOpen
            }
        }
        default: {
            return state
        }
    }
}

export default dashboard
